import Class from "../jquery_class";

export default Class.extend({
  init: function(name) {
    this.name = name || '';
  },

  toString: function(lowercase, plural, possessive, spacesInsteadOfUnderscores) {
    var result = this.name;

    if (!spacesInsteadOfUnderscores) {
      result = result.replace(' ', '_');
    }

    if (lowercase) {
      result = result.toLowerCase();
    }

    if (plural) {
      result += 's';
    }

    if (possessive && plural) {
      result += "'";
    } else if (possessive) {
      result += "'s";
    }

    return result;
  }
});
